import { useQuery } from '@tanstack/react-query';

async function getDataSyncConfiguration() {
  const response = await fetch('/ArchiveProcessor/Configuration', {
    method: 'GET'
  });

  if (response.status === 404) {
    return [];
  }

  if (response.error) {
    throw new Error('Failed fetch');
  }

  const data = await response.json();

  return [data];
}

export const queryKey = ['data-sync-configuration'];

export function useDataSyncConfiguration() {
  return useQuery({
    queryKey,
    staleTime: 1000 * 60 * 60, // 1 hour
    queryFn: async () => getDataSyncConfiguration()
  });
}
